import React from "react";

const Shelf = ({ label, children }) => {
  return (
    <div className="loop-shelf">
      {label && (
        <div className="loop-shelf__notch">
          <span className="loop-shelf__notch-label">{label.toUpperCase()}</span>
        </div>
      )}
      {children}
    </div>
  );
};

export default Shelf;
